import { render, staticRenderFns } from "./login-problem.vue?vue&type=template&id=7f40427a&scoped=true"
import script from "./login-problem.vue?vue&type=script&lang=js"
export * from "./login-problem.vue?vue&type=script&lang=js"
import style0 from "./login-problem.vue?vue&type=style&index=0&id=7f40427a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40427a",
  null
  
)

export default component.exports